<div
  class="tab-bar"
  [ngClass]="{
    'variant-primary': variant === 'primary',
    'variant-secondary': variant === 'secondary',
    'variant-tertiary': variant === 'tertiary'
  }"
>
  <!-- Tab headers/navigation -->
  <div class="tab-headers">
    <ng-content select="hyperkit-tab"></ng-content>
  </div>

  <!-- Tab content area (only for uncontrolled) -->
  <div class="tab-content-container" *ngIf="!controlled && selectedTab">
    <ng-container *ngFor="let tab of tabs">
      <div class="tab-panel" *ngIf="tab === selectedTab">
        <ng-container *ngTemplateOutlet="tab.contentTemplate"></ng-container>
      </div>
    </ng-container>
  </div>
</div>
